import { FC, useCallback } from 'react';

import { useListingContext } from 'shared/context/ListingContext';
import { boundActionsFactory } from 'shared/store/clientSide';
import { usePageSelector } from 'shared/store/clientSide/slices/jsonQuery/selectors/dumb';
import { extractUndefined } from 'shared/utils/extractUndefined';

import { PaginationController } from './PaginationController';
import { PaginationItem } from './types';

const useBoundActions = boundActionsFactory(reduxActions => ({
  setPage: reduxActions.jsonQuery.setPage,
}));

export const ListingPaginationContainer: FC = () => {
  const {
    listingProperties: { offersPerPage, totalOffers, maxPage },
  } = useListingContext();

  const boundActions = useBoundActions();

  const page = usePageSelector();

  const handlePageClick = useCallback<(paginationItem: PaginationItem) => void>(
    paginationItem => boundActions.setPage(paginationItem.page),
    [boundActions],
  );

  return (
    <PaginationController
      maxPage={extractUndefined(maxPage)}
      offersPerPage={offersPerPage}
      page={page}
      totalOffers={totalOffers}
      onPageClick={handlePageClick}
    />
  );
};
